export default "__VITE_ASSET__529c525b__"